import { defineStore } from "pinia";
import { APP_TOKEN, WEB_HTTP_AUTH_HEADER, CERTIFICATE_TABIND, INDENITY_ID, APP_ORGID, APP_ORGID_NAME, SEARCH_IND, CHOSE_TABLE, EXCLE_LIST, EXCLE_EVA_LIST } from "@/constants";
import { Storage } from "@/utils/Storage";
import UserService from '@/api/user';
import { ElMessage, ElMessageBox } from 'element-plus';
import router from '@/router';

// const useDetail = (path:string) => {
//     const router = useRouter(); //方法一
//     const goto = () => {
//       router.replace({ name: path }); //方法一
//     };
//     return { goto };
// };


interface UserStoreType {
  token: string;
  tokenHeader: string;
  userDetail: AppUser;
  certificatTabind: string;
  identityId: string;
  relationOrgId: string;
  relationOrgName: string;
  searchInd: number;
  choseTable: string;
  excleList: any;
  excleEvaList: any;
}

interface AppUser {
  id: string;
  mobile: string;
  nickname: string;
  realName: string;
  tokenName: string;
  tokenValue: string;
}

const useUserStore = defineStore("user", {
  state: (): UserStoreType => ({
    token: Storage.get(APP_TOKEN, "") as string,
    tokenHeader: Storage.get(WEB_HTTP_AUTH_HEADER, "hrttoken"),
    userDetail: Storage.get("APP_USER_INFO", {}),
    certificatTabind: Storage.get(CERTIFICATE_TABIND, "0"),
    identityId: Storage.get(INDENITY_ID, ""),
    relationOrgId: Storage.get(APP_ORGID, ""),
    relationOrgName: Storage.get(APP_ORGID_NAME, ""),
    searchInd: Storage.get(SEARCH_IND, 0),
    choseTable: Storage.get(CHOSE_TABLE, []),
    excleList: Storage.get(EXCLE_LIST,[]),
    excleEvaList: Storage.get(EXCLE_EVA_LIST,[]),
  }),
  actions: {
    setToken(value: string | undefined) {
      Storage.set(APP_TOKEN, value);
      this.token = value!;
    },
    setOrgId(value: string | undefined) {
      Storage.set(APP_ORGID, value);
      this.relationOrgId = value!;
    },
    setOrgIdName(value: string | undefined) {
      Storage.set(APP_ORGID_NAME, value);
      this.relationOrgName = value!;
    },
    setTokenHeader(value: string | undefined) {
      Storage.set(WEB_HTTP_AUTH_HEADER, value);
      this.tokenHeader = value!;
    },
    setCertificateSeclareTab(value: string | undefined) {
        Storage.set(CERTIFICATE_TABIND, value);
        this.certificatTabind = value!;
    },
    setIndenityId(value: string | undefined){
        Storage.set(INDENITY_ID, value);
        this.identityId = value!;
    },
    setSearchInd(value: number | undefined){
        Storage.set(SEARCH_IND, value);
        this.searchInd = value!;
    },
    saveChoseTable(value: string | undefined | any){
        // console.log(value,'5666666666666666666666666')
        Storage.set(CHOSE_TABLE, value)
        this.choseTable  = value!
    },
    saveTrainExcleList(value: any | undefined){
        Storage.set(EXCLE_LIST, value)
        this.excleList  = value!
    },
    saveEvateExcleList(value: any | undefined){
        Storage.set(EXCLE_EVA_LIST, value)
        this.excleEvaList  = value!
    },
    async appLogout() {
        useUserStore().setCertificateSeclareTab('0')
        if(useUserStore().identityId == '004001'||useUserStore().identityId==''||!useUserStore().identityId){
            router.push({path:"/login"})
        }else if(useUserStore().identityId == '004002'){
            router.push({path:"/evaluateLogin"})
        }else if(useUserStore().identityId == '004003'){
            router.push({path:"/managerLogin"})
        }else if(useUserStore().identityId == '004004'){
            router.push({path:"/expertLogin"})
        }
        ElMessage.info('登录失效，请重新登录');
        this.setToken("")
        Storage.clear()

        // const resp = await UserService.logout();
        // if (resp.code == 'SUCCESS') {
        //     useUserStore().setCertificateSeclareTab('0')
        //     ElMessage.success('退出成功');
        //     if(useUserStore().identityId == '004001'){
        //         // useRouter().push({ path: '/login' });
        //         // useDetail('login')
        //     }else if(useUserStore().identityId == '004002'){
        //         // useDetail('evaluateLogin')
        //         // useRouter().push({ path: '/evaluateLogin' });
        //     }else if(useUserStore().identityId == '004003'){
        //         // useRouter().push({ path: '/managerLogin' });
        //         // useDetail('managerLogin')
        //     }else{
        //         // useRouter().push({ path: '/login' });
        //         // useDetail('login')
        //     }
        // }
    },
  }
});

export { useUserStore };
